<template>
  <div class="alarmDetails-container">
    <el-row class="alarm-content">
      <el-row class="button">
        <el-button type="primary" @click="goBack">返回</el-button>
      </el-row>
      <el-row class="map-wrapper">
        <div id="alarmMap"></div>
        <div class="information">
          <el-row>
            <span>车牌号：</span>
            <span>{{ $judgeEmpty(vehicleLocation.plate) }}</span>
          </el-row>
          <el-row>
            <span>车辆绑定人：</span>
            <span>{{ $judgeEmpty(vehicleLocation.ownerName) }}</span>
          </el-row>
          <el-row>
            <span>代维公司：</span>
            <span>{{ $judgeEmpty(vehicleLocation.companyName) }}</span>
          </el-row>
          <el-row>
            <span>部门：</span>
            <span>{{ $judgeEmpty(vehicleLocation.deptName) }}</span>
          </el-row>
          <el-row>
            <span>运维小组：</span>
            <span>{{ $judgeEmpty(vehicleLocation.groupName) }}</span>
          </el-row>
        </div>
        <!-- 高德地图点击车辆标注显示的盒子 -->
        <el-row class="infoWindow" ref="vehicleInfoWindow" v-show="vehicleId">
          <i class="delta"></i>
          <el-row class="content">
            <el-row>
              <span>告警位置：</span>
              <span>{{ $judgeEmpty(address) }}</span>
            </el-row>
            <el-row>
              <span>告警开始时间：</span>
              <span>{{ $judgeEmpty(vehicleLocation.startTime) }}</span>
            </el-row>
            <el-row v-if="!historyVisible">
              <span>告警解除时间：</span>
              <span>{{ $judgeEmpty(vehicleLocation.endTime) }}</span>
            </el-row>
            <el-row>
              <span>告警历时（分钟）：</span>
              <span>{{ $judgeEmpty(vehicleLocation.takeTime) }}</span>
            </el-row>
            <el-row>
              <span>告警名称：</span>
              <span :class="[vehicleLocation.warnName ? 'red' : '']">{{
                $judgeEmpty(vehicleLocation.warnName)
              }}</span>
            </el-row>
          </el-row>
        </el-row>
        <div class="eCharts">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="剩余油量" name="remainL">
              <div class="content" id="remainL"></div>
            </el-tab-pane>
            <el-tab-pane label="发动机转速" name="engineSpeed">
              <div class="content" id="engineSpeed"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "AlarmDetails",
  data() {
    return {
      map: null,
      activeName: "remainL",
      warnId: null,
      warnVin: "",
      historyWarnId: null,
      historyWarnVin: "",
      vehicleLocation: {},
      marker: null,
      geocoder: null,
      infoWindow: null,
      vehicleId: false,
      address: "",
      oilDataX: [],
      oilDataY: [],
      rpmDataX: [],
      rpmDataY: [],
      historyVisible: false,
    };
  },
  created() {
    // 实时数据
    this.warnId =
      this.$route.params.id ||
      this.$route.params.historyId ||
      sessionStorage.getItem("warnId");
    this.warnVin =
      this.$route.params.vin ||
      this.$route.params.historyVin ||
      sessionStorage.getItem("warnVin");
    sessionStorage.setItem("warnId", this.warnId);
    sessionStorage.setItem("warnVin", this.warnVin);
    // 历史数据
    this.historyWarnId =
      this.$route.params.historyId || sessionStorage.getItem("historyWarnId");
    this.historyWarVin =
      this.$route.params.historyVin || sessionStorage.getItem("historyWarnVin");
    sessionStorage.setItem("historyWarnId", this.historyWarnId);
    sessionStorage.setItem("historyWarVin", this.historyWarVin);
  },
  mounted() {
    this.initMap();
    this.getVehicleLocation();
  },
  methods: {
    goBack() {
      if (this.$route.params.id) {
        this.$router.push({
          name: "AlarmMonitor",
          params: {
            vin: this.warnVin,
            alarmCurPage: sessionStorage.getItem("alarmCurPage"),
            currentPage: sessionStorage.getItem("alarmCurrentPage"),
          },
        });
        this.$store.state.MenuStore.menu_path = "告警监控";
        sessionStorage.removeItem("warnId");
        sessionStorage.removeItem("warnVin");
      }
      if (this.$route.params.historyId) {
        this.historyVisible = false;
        this.$router.push({
          name: "HistoryAlarm",
          params: {
            vin: this.historyWarnId,
            currentPage: sessionStorage.getItem("historyAlarmCurrentPage"),
          },
        });
        sessionStorage.removeItem("historyWarnId");
        sessionStorage.removeItem("historyWarVin");
      }
    },
    handleClick() {
      let obj = {
        vin: this.warnVin,
        endTime: this.vehicleLocation.startTime,
        startTime: this.vehicleLocation.endTime,
      };
      if (this.activeName == "remainL") {
        this.getOilCharts(obj);
      } else {
        this.getRpmCharts(obj);
      }
    },
    // 实时告警数据和历史告警数据
    async getVehicleLocation() {
      let obj = {};
      obj.id = this.warnId;
      let { data: res } = await this.$axios.get(
        "/api/warn/remind/details/infoV2",
        {
          params: obj,
        }
      );
      console.log(res.data);
      if (res.code == 1) {
        this.vehicleLocation = res.data;
        if (this.historyWarnId) {
          this.historyVisible = true;
          this.historyVehicleLocation = res.data;
        }
        this.getCharts();
        console.log([
          this.vehicleLocation.longitude,
          this.vehicleLocation.latitude,
        ]);
        this.vehicleLocation.longitude =
          this.vehicleLocation.longitude || this.vehicleLocation.lnglat[0];
        this.vehicleLocation.latitude =
          this.vehicleLocation.latitude || this.vehicleLocation.lnglat[1];
        if (this.vehicleLocation.longitude && this.vehicleLocation.latitude) {
          // 创建 AMap.Icon 实例：
          let icon = new AMap.Icon({
            size: new AMap.Size(40, 40), // 图标尺寸
            image: require("@/assets/images/geological/order/unfinished.png"), // Icon的图像
            imageOffset: new AMap.Pixel(2, 0), // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(23, 36), // 根据所设置的大小拉伸或压缩图片
          });
          this.marker = new AMap.Marker({
            position: [
              this.vehicleLocation.longitude,
              this.vehicleLocation.latitude,
            ],
            icon: icon,
          });
          this.map.setCenter([
            this.vehicleLocation.longitude,
            this.vehicleLocation.latitude,
          ]);
          this.map.add(this.marker);
          // this.addBaseStationMarks();
          // this.addStationBankMarks();
          // this.addFaultStationBankMarks();
          // this.marker.on("click", () => {
          console.log("marker clicked");
          this.vehicleId = true;
          let location = [
            this.vehicleLocation.longitude,
            this.vehicleLocation.latitude,
          ];
          this.geocoder.getAddress(location, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              this.address = result.regeocode.formattedAddress;
              this.infoWindow.show();
              this.infoWindow.setPosition(location);
            }
          });
          // });
        }
      }
    },
    getCharts() {
      // // 将当前告警时间往前取五分钟
      // let date = new Date(this.vehicleLocation.startTime);
      // let time = date.getMinutes();
      // date.setMinutes(time - 5);
      // this.startTime = date;
      let obj = {
        vin: this.warnVin,
        endTime: this.vehicleLocation.startTime,
        startTime: this.vehicleLocation.endTime,
        deviceId: this.vehicleLocation.deviceId,
      };
      if (this.activeName == "remainL") {
        this.getOilCharts(obj);
      } else {
        this.getRpmCharts(obj);
      }
    },
    // 查询剩余油量
    async getOilCharts(obj) {
      let { data: res } = await this.$axios.get(
        "/api/vehicle/details/dynamo/counts/AdFuel",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.oilDataX = [];
        this.oilDataY = [];
        res.data.map((item) => {
          if (item.forwardPower != 65535) {
            this.oilDataX.push(item.ts);
            this.oilDataY.push(item.adFuel);
          }
        });
        this.$nextTick(() => {
          this.initCharts("remainL", "剩余油量", this.oilDataX, this.oilDataY);
        });
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 查询发动机转速
    async getRpmCharts(obj) {
      let { data: res } = await this.$axios.get(
        "/api/vehicle/details/engine/speed/kChart",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.rpmDataX = [];
        this.rpmDataY = [];
        res.data.map((item) => {
          if (item.forwardPower != 65535) {
            this.rpmDataX.push(item.ts);
            this.rpmDataY.push(item.emsEngineSpeed);
          }
        });
        this.$nextTick(() => {
          this.initCharts(
            "engineSpeed",
            "发动机转速",
            this.rpmDataX,
            this.rpmDataY
          );
        });
      } else {
        this.$message.warning(res.msg);
      }
    },

    initMap() {
      this.map = new AMap.Map("alarmMap", {
        zoom: 15, //级别
        resizeEnable: true,
      });
      this.geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      // 车辆信息窗体 anchor:bottom-center 正上方显示信息窗体
      this.infoWindow = new AMap.Marker({
        map: this.map,
        anchor: "bottom-center",
        content: this.$refs.vehicleInfoWindow.$el,
        zIndex: 300,
        offset: new AMap.Pixel(30, -48),
      });
      // 点击地图，清除路线规划和车辆信息窗体
      AMap.event.addListener(this.map, "click", () => {
        this.infoWindow.hide();
      });
    },

    initCharts(id, name, dataX, dataY) {
      // 没有数据时处理，使用 title 显示暂无数据
      dataY.forEach((item) => {
        if (item == "") {
          dataY = [];
        }
      });
      let showed = dataY.length ? false : true;
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(id));
      // 指定图表的配置项和数据
      let option = {
        title: {
          show: showed,
          text: "暂无数据...",
          left: "center",
          top: "center",
          textStyle: {
            fontWeight: "normal",
            color: "#999999",
          },
        },
        tooltip: {
          trigger: "axis",
          position: function(pt) {
            return [pt[0], "10%"];
          },
          // 为剩余油量图表提示器添加单位
          formatter: function(params) {
            let relVal = params[0].name;
            let labelVal = params[0].seriesName;
            for (let i = 0, l = params.length; i < l; i++) {
              if (id == "engineSpeed") {
                relVal +=
                  "<br/>" +
                  params[i].marker +
                  labelVal +
                  ":" +
                  " " +
                  params[i].value;
              } else {
                relVal +=
                  "<br/>" +
                  params[i].marker +
                  labelVal +
                  ":" +
                  " " +
                  params[i].value +
                  "L";
              }
            }
            return relVal;
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            restore: {},
            saveAsImage: {},
          },
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "8%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          position: "bottom",
          data: dataX,
          splitLine: {
            show: false,
          },
          axisLabel: {
            showMaxLabel: true,
            show: true,
            formatter: function(value) {
              var date = value.split(" ")[0];
              var time = value.split(" ")[1];
              return time + "\n" + date;
            },
          },
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          position: "left",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: "#f9f9f9",
            },
          },
        },
        dataZoom: [
          {
            show: true,
            type: "slider",
            xAxisIndex: 0,
            filterMode: "filte",
          },
          {
            type: "inside",
            xAxisIndex: 0,
            filterMode: "filte",
          },
        ],
        series: [
          {
            name: name,
            type: "line",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgb(255, 70, 131)",
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 158, 68)",
                },
                {
                  offset: 1,
                  color: "rgb(255, 70, 131)",
                },
              ]),
            },
            data: dataY,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);

      // 图表响应式
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alarmDetails-container {
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  .alarm-content {
    width: 100%;
    height: 100%;
    padding: 20px;
    .button {
      margin-bottom: 20px !important;
    }
    .map-wrapper {
      position: relative;
      width: 100%;
      height: calc(100% - 52px);
      #alarmMap {
        width: 100%;
        height: 100%;
        border: 1px solid #cbcbcb;
      }
      .eCharts {
        position: absolute;
        left: 1px;
        right: -1px;
        bottom: -1px;
        background: #fafafa;
        box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.3);
        /deep/ .el-tabs__nav-scroll {
          padding-left: 20px;
        }
        .content {
          height: 240px;
          background: #fff;
        }
      }
      .information {
        position: absolute;
        left: 10px;
        top: 10px;
        width: 260px;
        height: 168px;
        line-height: 33px;
        padding: 20px 15px;
        background: #000;
        opacity: 0.8;
        color: #fff;
        font-size: 14px;
      }
      .infoWindow {
        position: relative;
        padding: 10px;
        background: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333;
        width: 300px;
        border-radius: 4px;
        box-sizing: border-box;
        .red {
          color: #f82f2f;
        }
        .content {
          line-height: 30px;
        }
        // 三角形
        .delta {
          position: absolute;
          left: 40%;
          bottom: -12px;
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-right: 10px solid rgba(255, 255, 255, 0.8);
          border-bottom: 8px solid transparent;
          transform: rotate(-90deg);
        }
      }
    }
  }
}
</style>
